/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-underscore-dangle */
import React, { Component } from 'react'

import classNames from 'classnames'

import 'perfect-scrollbar/css/perfect-scrollbar.css'
import PerfectScrollbar from 'perfect-scrollbar'

import './perfect-scrollbar.scss'

const handlerNameByEvent = {
  'ps-scroll-y': 'onScrollY',
  'ps-scroll-x': 'onScrollX',
  'ps-scroll-up': 'onScrollUp',
  'ps-scroll-down': 'onScrollDown',
  'ps-scroll-left': 'onScrollLeft',
  'ps-scroll-right': 'onScrollRight',
  'ps-y-reach-start': 'onYReachStart',
  'ps-y-reach-end': 'onYReachEnd',
  'ps-x-reach-start': 'onXReachStart',
  'ps-x-reach-end': 'onXReachEnd',
}
Object.freeze(handlerNameByEvent)

class ScrollBar extends Component {
  _ps = null

  _handlerByEvent = {}

  constructor(props) {
    super(props)

    this.handleRef = this.handleRef.bind(this)
    // this._handlerByEvent = {};
  }

  componentDidMount() {
    this.createPS()

    this.checkContainerResize()
  }

  componentDidUpdate(prevProps) {
    const { className } = this.getProps()
    this._updateEventHook(prevProps)

    this.updateScroll()

    if (prevProps.className !== className) {
      this._updateClassName()
    }
  }

  componentWillUnmount() {
    if (this.resizeObserver.clear != null) {
      this.resizeObserver.clear()
    }

    this.deletePS()
  }

  checkContainerResize = () => {
    if (this._container != null) {
      if (this.resizeObserver == null) {
        this.resizeObserver = {}

        this.resizeObserver.callUpdate = () => {
          if (this.resizeObserver.resizeTimer != null) {
            clearTimeout(this.resizeObserver.resizeTimer)
          }
          this.resizeObserver.resizeTimer = setTimeout(() => {
            // if (this._ps != null) {
            //   this.updateScroll();
            // }
            this.createPS()
          }, 300)
        }

        this.resizeObserver.observer = new ResizeObserver((e) => {
          console.log(' resize scrollContainer - ', e)
          this.resizeObserver.callUpdate()
        })

        this.resizeObserver.clear = () => {
          const { observer, element, resizeTimer } = this.resizeObserver
          if (observer != null && element != null) {
            observer.disconnect()
            if (resizeTimer != null) {
              clearTimeout(resizeTimer)
            }
          }
        }
      }

      if (this.resizeObserver.element !== this._container) {
        this.resizeObserver.clear()

        this.resizeObserver.element = this._container

        if (this.resizeObserver.element != null) {
          this.resizeObserver.callUpdate()
          this.resizeObserver.observer.observe(this.resizeObserver.element, {
            box: 'border-box',
          })
        }
      }
    }
  }

  createPS = () => {
    const { options, refScroll } = this.getProps()
    if (this._ps != null) {
      this.deletePS()
    }
    if (this._container != null) {
      this._ps = new PerfectScrollbar(this._container, options)
      // hook up events
      this._updateEventHook()
      this._updateClassName()

      const refType = typeof refScroll
      if (refType === 'function') {
        refScroll(this._ps)
      } else if (refType === 'object') {
        refScroll.current = this._ps
      }

      setTimeout(() => {
        this.updateScroll()
      }, 300)
    }
  }

  deletePS = () => {
    // unhook up evens
    Object.keys(this._handlerByEvent).forEach((key) => {
      const value = this._handlerByEvent[key]

      if (value) {
        this._container.removeEventListener(key, value, false)
      }
    })
    this._handlerByEvent = {}
    this._ps.destroy()
    this._ps = null
  }

  getProps = () => {
    return {
      className: '',
      style: undefined,
      options: undefined,
      refScroll: () => {},
      onScrollY: undefined,
      onScrollX: undefined,
      onScrollUp: undefined,
      onScrollDown: undefined,
      onScrollLeft: undefined,
      onScrollRight: undefined,
      onYReachStart: undefined,
      onYReachEnd: undefined,
      onXReachStart: undefined,
      onXReachEnd: undefined,
      height: undefined,
      component: 'div',
      always: false,
      thumbHover: false,
      ...this.props,
    }
  }

  _updateEventHook = (prevProps = {}) => {
    // hook up events
    Object.keys(handlerNameByEvent).forEach((key) => {
      const callback = this.props[handlerNameByEvent[key]]
      const prevCallback = prevProps[handlerNameByEvent[key]]
      if (callback !== prevCallback) {
        if (prevCallback) {
          const prevHandler = this._handlerByEvent[key]
          this._container.removeEventListener(key, prevHandler, false)
          this._handlerByEvent[key] = null
        }
        if (callback) {
          const handler = (e) => callback(e, this.__ps)
          this._container.addEventListener(key, handler, false)
          this._handlerByEvent[key] = handler
        }
      }
    })
  }

  _updateClassName = () => {
    const { always, thumbHover } = this.getProps()

    const psClassNames = this._container.className
      .split(' ')
      .filter((name) => name.match(/^ps([-_].+|)$/))
      .join(' ')

    const clsNames = ['scroll-content']
    if (psClassNames != null && psClassNames.trim().length > 0) {
      clsNames.push(psClassNames)
    }
    if (always === true) {
      clsNames.push('always')
    }
    if (thumbHover === true) {
      clsNames.push('thumb-hover')
    }

    if (this._container) {
      this._container.className = clsNames.join(' ')
    }
  }

  updateScroll = () => {
    if (this._ps != null) {
      this._ps.update()
    }
  }

  handleRef = (ref) => {
    if (ref != null) {
      this._container = ref
      this.createPS()
    }
  }

  render() {
    const {
      className,
      style,
      options,
      refScroll,
      onScrollY,
      onScrollX,
      onScrollUp,
      onScrollDown,
      onScrollLeft,
      onScrollRight,
      onYReachStart,
      onYReachEnd,
      onXReachStart,
      onXReachEnd,
      component,
      children,
      height,
      always,
      thumbHover,
      ...remainProps
    } = this.getProps()

    const Comp = component

    const newStyle = { ...style }
    if (height != null) {
      newStyle.height = height
    }

    return (
      <div className={classNames('perfect-list', className)} style={newStyle}>
        <Comp ref={this.handleRef} {...remainProps}>
          {children}
        </Comp>
      </div>
    )

    // return (
    //   <Comp ref={this.handleRef} {...remainProps} style={newStyle}>
    //     {children}
    //   </Comp>
    // );
  }
}

export default ScrollBar
